// import {
//   FETCH_IPD_LIST_REQUEST,
//   FETCH_IPD_LIST_SUCCESS,
//   FETCH_IPD_LIST_FAILURE,
//   FETCH_IPD_DETAIL_REQUEST,
//   FETCH_IPD_DETAIL_SUCCESS,
//   FETCH_IPD_DETAIL_FAILURE,
//   ADD_IPD_ADMISSION_REQUEST,
//   ADD_IPD_ADMISSION_SUCCESS,
//   ADD_IPD_ADMISSION_FAILURE,
//   UPDATE_IPD_ADMISSION_REQUEST,
//   UPDATE_IPD_ADMISSION_SUCCESS,
//   UPDATE_IPD_ADMISSION_FAILURE,
//   ASSIGN_IPD_DOCTOR_REQUEST,
//   ASSIGN_IPD_DOCTOR_SUCCESS,
//   ASSIGN_IPD_DOCTOR_FAILURE,
//   CLEAR_IPD_DETAIL,
// } from "../actions/ipdActions";

// const initialState = {
//   ipdList: [],
//   ipdDetail: null,
//   isLoading: false,       // list fetch
//   detailLoading: false,   // single admission fetch
//   addLoading: false,      // add admission
//   updateLoading: false,   // update admission
//   assignLoading: false,   // assign doctor
//   error: null,
// };

// export const ipdReducer = (state = initialState, action) => {
//   switch (action.type) {
//     // ── List ─────────────────────────────────────────────────────────────────
//     case FETCH_IPD_LIST_REQUEST:
//       return { ...state, isLoading: true, error: null };

//     case FETCH_IPD_LIST_SUCCESS:
//       return { ...state, ipdList: action.payload, isLoading: false };

//     case FETCH_IPD_LIST_FAILURE:
//       return { ...state, error: action.payload, isLoading: false };

//     // ── Detail ────────────────────────────────────────────────────────────────
//     case FETCH_IPD_DETAIL_REQUEST:
//       return { ...state, detailLoading: true, error: null };

//     case FETCH_IPD_DETAIL_SUCCESS:
//       return { ...state, ipdDetail: action.payload, detailLoading: false };

//     case FETCH_IPD_DETAIL_FAILURE:
//       return { ...state, error: action.payload, detailLoading: false };

//     case CLEAR_IPD_DETAIL:
//       return { ...state, ipdDetail: null };

//     // ── Add ───────────────────────────────────────────────────────────────────
//     case ADD_IPD_ADMISSION_REQUEST:
//       return { ...state, addLoading: true, error: null };

//     case ADD_IPD_ADMISSION_SUCCESS:
//       return { ...state, addLoading: false };

//     case ADD_IPD_ADMISSION_FAILURE:
//       return { ...state, addLoading: false, error: action.payload };

//     // ── Update ────────────────────────────────────────────────────────────────
//     case UPDATE_IPD_ADMISSION_REQUEST:
//       return { ...state, updateLoading: true, error: null };

//     case UPDATE_IPD_ADMISSION_SUCCESS:
//       return { ...state, updateLoading: false };

//     case UPDATE_IPD_ADMISSION_FAILURE:
//       return { ...state, updateLoading: false, error: action.payload };

//     // ── Assign Doctor ─────────────────────────────────────────────────────────
//     case ASSIGN_IPD_DOCTOR_REQUEST:
//       return { ...state, assignLoading: true, error: null };

//     case ASSIGN_IPD_DOCTOR_SUCCESS:
//       return { ...state, assignLoading: false };

//     case ASSIGN_IPD_DOCTOR_FAILURE:
//       return { ...state, assignLoading: false, error: action.payload };

//     default:
//       return state;
//   }
// };

import {
  FETCH_IPD_LIST_REQUEST,
  FETCH_IPD_LIST_SUCCESS,
  FETCH_IPD_LIST_FAILURE,
  FETCH_IPD_DETAIL_REQUEST,
  FETCH_IPD_DETAIL_SUCCESS,
  FETCH_IPD_DETAIL_FAILURE,
  ADD_IPD_ADMISSION_REQUEST,
  ADD_IPD_ADMISSION_SUCCESS,
  ADD_IPD_ADMISSION_FAILURE,
  UPDATE_IPD_ADMISSION_REQUEST,
  UPDATE_IPD_ADMISSION_SUCCESS,
  UPDATE_IPD_ADMISSION_FAILURE,
  ASSIGN_IPD_DOCTOR_REQUEST,
  ASSIGN_IPD_DOCTOR_SUCCESS,
  ASSIGN_IPD_DOCTOR_FAILURE,
  CLEAR_IPD_DETAIL,
  FETCH_ACTIVE_IPD_ASSIGNMENT_REQUEST,
  FETCH_ACTIVE_IPD_ASSIGNMENT_SUCCESS,
  FETCH_ACTIVE_IPD_ASSIGNMENT_FAILURE,
  CREATE_IPD_ASSIGNMENT_REQUEST,
  CREATE_IPD_ASSIGNMENT_SUCCESS,
  CREATE_IPD_ASSIGNMENT_FAILURE,
  SAVE_IPD_ASSIGNMENT_ROSTER_REQUEST,
  SAVE_IPD_ASSIGNMENT_ROSTER_SUCCESS,
  SAVE_IPD_ASSIGNMENT_ROSTER_FAILURE,
} from "../actions/ipdActions";

const initialState = {
  ipdList: [],
  ipdDetail: null,
  isLoading: false,       // list fetch
  detailLoading: false,   // single admission fetch
  addLoading: false,      // add admission
  updateLoading: false,   // update admission
  assignLoading: false,   // quick doctor reassignment
  error: null,

  // IPD Patient Assignment (ward/bed/nurse/duty-doctor roster)
  assignmentsByAdmissionId: {}, // { [admissionId]: { status: 'idle'|'loading'|'loaded'|'error', data } }
  assignmentCreating: false,    // Assign Patient modal submit
  assignmentCreateError: null,
  assignmentRosterSaving: false, // Manage modal submit
  assignmentRosterError: null,
};

export const ipdReducer = (state = initialState, action) => {
  switch (action.type) {
    // ── List ─────────────────────────────────────────────────────────────────
    case FETCH_IPD_LIST_REQUEST:
      return { ...state, isLoading: true, error: null };

    case FETCH_IPD_LIST_SUCCESS:
      return { ...state, ipdList: action.payload, isLoading: false };

    case FETCH_IPD_LIST_FAILURE:
      return { ...state, error: action.payload, isLoading: false };

    // ── Detail ────────────────────────────────────────────────────────────────
    case FETCH_IPD_DETAIL_REQUEST:
      return { ...state, detailLoading: true, error: null };

    case FETCH_IPD_DETAIL_SUCCESS:
      return { ...state, ipdDetail: action.payload, detailLoading: false };

    case FETCH_IPD_DETAIL_FAILURE:
      return { ...state, error: action.payload, detailLoading: false };

    case CLEAR_IPD_DETAIL:
      return { ...state, ipdDetail: null };

    // ── Add ───────────────────────────────────────────────────────────────────
    case ADD_IPD_ADMISSION_REQUEST:
      return { ...state, addLoading: true, error: null };

    case ADD_IPD_ADMISSION_SUCCESS:
      return { ...state, addLoading: false };

    case ADD_IPD_ADMISSION_FAILURE:
      return { ...state, addLoading: false, error: action.payload };

    // ── Update ────────────────────────────────────────────────────────────────
    case UPDATE_IPD_ADMISSION_REQUEST:
      return { ...state, updateLoading: true, error: null };

    case UPDATE_IPD_ADMISSION_SUCCESS:
      return { ...state, updateLoading: false };

    case UPDATE_IPD_ADMISSION_FAILURE:
      return { ...state, updateLoading: false, error: action.payload };

    // ── Assign Doctor (quick reassignment) ──────────────────────────────────
    case ASSIGN_IPD_DOCTOR_REQUEST:
      return { ...state, assignLoading: true, error: null };

    case ASSIGN_IPD_DOCTOR_SUCCESS:
      return { ...state, assignLoading: false };

    case ASSIGN_IPD_DOCTOR_FAILURE:
      return { ...state, assignLoading: false, error: action.payload };

    // ── IPD Patient Assignment: active roster fetch ─────────────────────────
    case FETCH_ACTIVE_IPD_ASSIGNMENT_REQUEST:
      return {
        ...state,
        assignmentsByAdmissionId: {
          ...state.assignmentsByAdmissionId,
          [action.admissionId]: {
            status: "loading",
            data: state.assignmentsByAdmissionId[action.admissionId]?.data || null,
          },
        },
      };

    case FETCH_ACTIVE_IPD_ASSIGNMENT_SUCCESS:
      return {
        ...state,
        assignmentsByAdmissionId: {
          ...state.assignmentsByAdmissionId,
          [action.admissionId]: { status: "loaded", data: action.payload },
        },
      };

    case FETCH_ACTIVE_IPD_ASSIGNMENT_FAILURE:
      return {
        ...state,
        assignmentsByAdmissionId: {
          ...state.assignmentsByAdmissionId,
          [action.admissionId]: { status: "error", data: null },
        },
      };

    // ── IPD Patient Assignment: create ──────────────────────────────────────
    case CREATE_IPD_ASSIGNMENT_REQUEST:
      return { ...state, assignmentCreating: true, assignmentCreateError: null };

    case CREATE_IPD_ASSIGNMENT_SUCCESS:
      return { ...state, assignmentCreating: false };

    case CREATE_IPD_ASSIGNMENT_FAILURE:
      return { ...state, assignmentCreating: false, assignmentCreateError: action.payload };

    // ── IPD Patient Assignment: save roster (Manage modal) ──────────────────
    case SAVE_IPD_ASSIGNMENT_ROSTER_REQUEST:
      return { ...state, assignmentRosterSaving: true, assignmentRosterError: null };

    case SAVE_IPD_ASSIGNMENT_ROSTER_SUCCESS:
      return { ...state, assignmentRosterSaving: false };

    case SAVE_IPD_ASSIGNMENT_ROSTER_FAILURE:
      return {
        ...state,
        assignmentRosterSaving: false,
        assignmentRosterError: action.payload,
      };

    default:
      return state;
  }
};